import React from 'react'
import Divider from 'components/visualization/MediaModal/Divider'

interface DividerWrapperProps {
  children: React.ReactNode
}

const DividerWrapper = ({ children }: DividerWrapperProps) => (
  <>
    {children}
    <Divider height="22px" />
  </>
)

export default DividerWrapper
